import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_ZONES } from '../get-zones';
import { createZoneAPI } from './api';

export function useCreateZone() {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const mutation = useMutation((zone) => createZoneAPI(zone), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_ZONES, tenantId]);
      openModal({
        modalType: 'NotificationModal',
        modalProps: { type: 'success', description: 'Zone created' },
      });
    },
    onError: () => {
      openModal({
        modalType: 'NotificationModal',
        modalProps: { type: 'error', description: 'genericErrorMessage' },
      });
    },
  });

  return {
    ...mutation,
  };
}

